import {
  Component,
  ElementRef,
  Input,
  OnChanges,
  ViewChild,
} from '@angular/core';
import { Chart, ChartConfiguration } from 'chart.js';
import { HandicapStats } from '../../../service/coursera-dashboard-stats.model';

@Component({
  selector: 'app-coursera-handicap-chart',
  templateUrl: './coursera-handicap-chart.component.html',
  styleUrls: ['./coursera-handicap-chart.component.css'],
})
export class CourseraHandicapChartComponent implements OnChanges {
  @Input() data: HandicapStats[] = [];
  @ViewChild('handicapChart') chartRef!: ElementRef;

  chart!: Chart;

  ngOnChanges(): void {
    // 🔥 si pas de données → on détruit le chart (important)
    if (!this.data || this.data.length === 0) {
      if (this.chart) {
        this.chart.destroy();
      }
      return;
    }

    // 🔥 attendre que le canvas soit présent
    setTimeout(() => {
      this.createChart();
    });
  }

  createChart() {
    if (!this.chartRef?.nativeElement) return;

    const ctx = this.chartRef.nativeElement.getContext('2d');

    const labels = this.data.map((d) => d.situation);
    const values = this.data.map((d) => d.total);

    // 🔥 reset du chart
    if (this.chart) {
      this.chart.destroy();
    }

    const config: ChartConfiguration = {
      type: 'pie',
      data: {
        labels: labels,
        datasets: [
          {
            data: values,
          },
        ],
      },
      options: {
        responsive: true,
      },
    };

    this.chart = new Chart(ctx, config);
  }
}
